import { useMemo } from "react";
export var useLookupInfoProps = function (fetchLookupInfo, initialState) { return useMemo(function () { return ({ fetchLookupInfo: fetchLookupInfo, initialState: initialState }); }, [fetchLookupInfo, initialState]); };
//# sourceMappingURL=use-lookup-info-props.js.map